var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage"},[_c('div',{staticClass:"homepage__menu"},_vm._l((_vm.items),function(item){return _c('HomepageColumn',{key:item.id,attrs:{"homepageItem":item}})}),1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage__image"},[_c('img',{attrs:{"src":require("../../assets/childrens.png"),"alt":""}})])
}]

export { render, staticRenderFns }